import type { AxiosResponse } from 'axios'
export default class ResponseError extends Error {
  declare response: AxiosResponse

  constructor(message: string, options: ErrorOptions, reponse: AxiosResponse) {
    super(message, { cause: options.cause })

    // Maintains proper stack trace for where our error was thrown (only available on V8)
    // @ts-ignore
    if (Error.captureStackTrace) {
      // @ts-ignore
      Error.captureStackTrace(this, ResponseError)
    }

    this.name = 'ResponseError'

    // CustomData
    this.response = reponse
  }
}
